<footer class="bg-[#090B0D] pt-9 text-white lg:pt-12 w-full px-4">
  <div class="flex flex-col gap-8">
    <div class="w-full space-y-2 md:mx-auto max-w-[min(100%,var(--container-2xl))]">
      <div class="text-center text-lg font-semibold text-ui-muted-foreground">
        {{ 'FOOTER.FORMATS' | translate }}
      </div>
      <div class="self-center flex flex-wrap justify-center gap-2">
        @for (row of formats; track $index) {
          <span
            class="py-1 px-2 hover:scale-[1.05] transition-all duration-300 bg-ui-primary text-white rounded-full font-semibold text-sm">
            {{ row }}
          </span>
        }
      </div>
    </div>

    <hr class="w-full flex h-px bg-ui-primary/10 rounded-full border-0" />

    <div class="flex w-full items-center text-center gap-6">
      <a routerLink="/" [attr.aria-label]="'FOOTER.HOME_ARIA' | translate">
        <img src="assets/images/logo-white.svg" alt="Imagise" class="h-12" />
      </a>
      <nav
        class="flex gap-4 items-center w-full justify-center font-medium"
        [attr.aria-label]="'FOOTER.LEGAL_NAV_ARIA' | translate">
        <a href="https://about.smallize.com/legal/privacy-policy/" class="footer__link">
          {{ 'FOOTER.LEGAL.PRIVACY_POLICY' | translate }}
        </a>
        <a href="https://about.smallize.com/legal/terms-of-use/" class="footer__link">
          {{ 'FOOTER.LEGAL.TERMS_OF_SERVICE' | translate }}
        </a>
        @if (showAnalyticsSettings()) {
          <button
            id="analytics-consent-settings"
            class="footer__link"
            type="button"
            (click)="openAnalyticsSettings.emit()">
            {{ 'FOOTER.LEGAL.ANALYTICS_SETTINGS' | translate }}
          </button>
        }
      </nav>
    </div>

    <div class="flex items-center justify-between text-xs">
      <p class="text-center text-ui-muted font-medium">{{ 'FOOTER.VERSION' | translate }}: {{ appVersion }}</p>
      <p class="text-ui-muted-foreground block text-center">
        {{ 'FOOTER.RIGHTS_RESERVED' | translate: { currentYear: currentYear } }}
      </p>
    </div>
  </div>
</footer>
